import React, { useContext } from 'react'
import styled, { ThemeContext } from 'styled-components'

import { useTranslation } from '../../i18n'
import VerifiedSvg from '../../public/static/images/pd-verify.svg'
import { resizeImg } from '../../utils/commonUtils'
import { getColor, getFontSize } from '../../utils/cssUtils'
import mq from '../../utils/mediaQuery'
import Avatar from '../Avatar'
import OrgLinkWrapper from '../OrgLinkWrapper'
import SvgIcon from '../SvgIcon'
import EllipsisText from '../Text/EllipsisText'

const Wrapper = styled.div`
  height: 80px;
  margin-bottom: 22px;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  ${mq.tablet} {
    height: 56px;
  }
  ${mq.mobile} {
    height: 64px;
    margin-bottom: 7px;
  }
`

const StyledAvatar = styled(Avatar)`
  ${mq.tablet} {
    width: 56px;
    height: 56px;
  }
  ${mq.mobile} {
    width: 64px;
    height: 64px;
  }
`

const AvatarInfoWrapper = styled.div`
  height: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  flex-grow: 1;
  margin-left: 12px;
  overflow: hidden;
  ${mq.mobile} {
    margin-left: 16px;
  }
`
const NameWithBadge = styled.div`
  display: flex;
  width: 100%;
`
const AvatarName = styled.div`
  height: 1.44em;
  overflow: hidden;
  width: ${({ showBadge }) => (showBadge ? 'auto' : '100%')};
  color: ${getColor('black')};
  > a {
    color: ${getColor('grey')};
  }
  font-weight: 600;
  font-size: ${getFontSize('title')};
  line-height: 1.44;
`
const AvatarNameText = styled(props => <EllipsisText as='h2' {...props} />)`
  margin: 0;
  color: inherit;
  font-size: ${getFontSize('title')};
`
const StyledSvgIcon = styled(SvgIcon)`
  vertical-align: middle;
  margin-left: 4px;
`
const ProjectCount = styled.div`
  font-size: ${getFontSize('body2')};
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1;
  letter-spacing: normal;
  color: ${getColor('grey')};
  margin-top: 4px;
  white-space: nowrap;
  ${mq.mobile} {
    margin-top: 0px;
  }
  > a {
    color: ${getColor('lightGrey')};
    &:hover {
      opacity: 1;
      color: ${getColor('pink')};
    }
  }
`

export const OrgAvatarInfo = ({
  avatar,
  name,
  organizationNo,
  projectCount,
  onLinkClick
}) => {
  const { t } = useTranslation()

  const { color } = useContext(ThemeContext)

  return (
    <Wrapper>
      <OrgLinkWrapper
        organizationNo={organizationNo}
        organizationName={name}
        onLinkClick={onLinkClick}
      >
        <StyledAvatar
          src={resizeImg(avatar, 96)}
          size={80}
          borderColor={color.border}
        />
      </OrgLinkWrapper>
      <AvatarInfoWrapper>
        <AvatarName>
          <AvatarNameText>
            <OrgLinkWrapper
              organizationNo={organizationNo}
              organizationName={name}
              onLinkClick={onLinkClick}
            >
              {name}
            </OrgLinkWrapper>
          </AvatarNameText>
        </AvatarName>
        <ProjectCount>
          <OrgLinkWrapper
            organizationNo={organizationNo}
            organizationName={name}
            onLinkClick={onLinkClick}
          >
            {projectCount + t('featuredProject.projects')}
          </OrgLinkWrapper>
        </ProjectCount>
      </AvatarInfoWrapper>
    </Wrapper>
  )
}

export const MemberAvatarInfo = ({
  avatar,
  name,
  projectCount,
  showOrganizationVerifiedBadge,
  useCorporateCreator
}) => {
  const { t } = useTranslation()

  const { color } = useContext(ThemeContext)

  return (
    <Wrapper>
      <StyledAvatar
        src={resizeImg(avatar, 96)}
        size={80}
        borderColor={color.border}
      />
      <AvatarInfoWrapper>
        <NameWithBadge>
          <AvatarName showBadge={showOrganizationVerifiedBadge}>
            <AvatarNameText>
              {t('personalFundraising.pageCreator') + name}
            </AvatarNameText>
          </AvatarName>
          {showOrganizationVerifiedBadge && (
            <StyledSvgIcon svg={<VerifiedSvg />} />
          )}
        </NameWithBadge>
        {!useCorporateCreator && (
          <ProjectCount>
            {projectCount + t('featuredProject.projects')}
          </ProjectCount>
        )}
      </AvatarInfoWrapper>
    </Wrapper>
  )
}
